import './add-collector.component.js';
import './add-collector.controller.js';



// WEBPACK FOOTER //
// ./components/collector/add/index.js